import React, {useEffect, useState} from 'react';
import {API_ROOT} from '../../../baseUrls';
import {connect} from 'react-redux';
import {updateBirthday, updateLocation, updateMindfileName,} from '../../../state/actions/updateDataActions';
import {Button, Card, CardContent, FormControl, Grid, TextField, Typography,} from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import FileMap from "../explore/items/item-map/FileMap";
import ProfilePhotoEdit from "../../organisms/app-bar/mindfile-bar/ProfilePhotoEdit";
import ProfilePhotoDisplay from "../../organisms/app-bar/mindfile-bar/ProfilePhotoDisplay";
import Location from "../../util/common/Location";

function Profile({user, mindfile, updateMindfileName, updateBirthday, updateLocation,}) {
  const [mindfileName, setMindfileName] = useState(mindfile.name || '');
  const [birthday, setBirthday] = useState(mindfile.birthday ?
    (typeof(mindfile.birthday) === "string" ? new Date(mindfile.birthday.replace(/-/g, '/')) : mindfile.birthday) : new Date());
  const [location, setLocation] = useState(mindfile.location || {
    latitude: '',
    longitude: '',
    country: '',
    locality: '',
    region: '',
  });

  useEffect(() => {
    setMindfileName(mindfile.name);
    setBirthday(typeof(mindfile.birthday) === "string" ? new Date(mindfile.birthday.replace(/-/g, '/')) : mindfile.birthday);
    if (mindfile.location) {
      setLocation(mindfile.location);
    }
  }, [mindfile]);

  const updateProfile = () => {
    const formData = new FormData()
    formData.append("mindfile[name]", mindfileName)
    !!birthday && formData.append("mindfile[birthday]", birthday)
    !!location.locality && formData.append("location[locality]", location.locality)
    !!location.region && formData.append("location[region]", location.region)
    !!location.country && formData.append("location[country]", location.country)
    !!location.latitude && formData.append("location[latitude]", location.latitude)
    !!location.longitude && formData.append("location[longitude]", location.longitude)

    fetch(`${ API_ROOT }/mindfiles/${ mindfile.id }/update`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
      headers: {'X-CSRF-Token': user.authenticity_token},
    })
    .then(resp => (resp.json()))
    .then(data => {
      if (data.status === 'ok') {
        updateMindfileName(mindfileName)
        updateBirthday(birthday)
        updateLocation(location)
      }
    })
    .catch(error => console.error(error))
  }

  return (
    <Card style={{ marginBottom: 24 }}>
      <CardContent>
        <Typography variant="subtitle1" gutterBottom>
          Profile
        </Typography>
        <Grid container justifyContent="flex-start" spacing={3}>
          <Grid item xs={12} md={6}>
            <div>
              <div>Mindfile name: {mindfile.name}</div>
            </div>
            <div>
              <div>Username: {user.username}</div>
            </div>
            <div>
              {mindfile.birthday ? <div>Birthday: {typeof(mindfile.birthday) === "string" ? new Date(mindfile.birthday.replace(/-/g, '/')).toLocaleDateString() : mindfile.birthday.toLocaleDateString()}</div> : ''}
            </div>
            <div>
              <div style={{display: "flex", flexWrap: "wrap", gap: "0.5rem"}}>
                <div>Location:</div>
                <Location
                  location={mindfile.location}
                  style={{display: "flex", flexWrap: "wrap", gap: "0.5rem", alignItems: "center"}}
                />
              </div>
            </div>
            <div style={{display: "flex"}}>
              <div style={{display: "flex", flexDirection: "column", alignItems: "center", gap: "0.5rem", marginTop: "1rem"}}>
                <div>Profile Photo:</div>
                <ProfilePhotoDisplay />
                <ProfilePhotoEdit />
              </div>
            </div>
          </Grid>

          <Grid item xs={12} md={6}>
            <div>
              <TextField
                label="New mindfile name"
                value={mindfileName}
                margin="dense"
                size="small"
                fullWidth
                onChange={e => setMindfileName(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div>
              <FormControl variant="outlined">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="New birthday"
                    inputFormat="MM/dd/yyyy"
                    value={birthday}
                    onChange={value => !!value && setBirthday(value)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        size="small"
                        margin="dense"
                      />
                    )}
                  />
                </LocalizationProvider>
                {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    disableToolbar
                    inputVariant="outlined"
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="dense"
                    label="New birthday"
                    size="small"
                    value={birthday}
                    onChange={value => !!value && setBirthday(value)}
                  />
                </MuiPickersUtilsProvider> */}
              </FormControl>
            </div>
            <div style={{marginTop:'1em'}}>
              <FileMap
                size="large"
                isDraggable={true}
                updateLocation={setLocation}
                location={location}
              />
            </div>
            <div>
              <Button variant="contained" color="primary" onClick={updateProfile}>Update</Button>
            </div>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

const mapStateToProps = state => {
  return {
    user: state.auth,
    mindfile: state.mindfile,
  }
};

const mapDispatchToProps = {
  updateMindfileName,
  updateBirthday,
  updateLocation,
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
